<script>
import { defineComponent, ref, computed } from "@vue/composition-api";
import BillingEditTemplate from "../templates/BillingEditTemplate.vue";
import { convertFormToBilling } from "@/functions/billing/convertFormToBilling";

export default defineComponent({
  name: "BillingEditPage",
  components: { BillingEditTemplate },
  props: {
    id: {
      type: String,
      default: "",
    },
    billingId: {
      type: String,
      default: "",
    },
  },
  setup(props, { root }) {
    const form = ref({});

    const billedUser = computed(() => {
      return root.$store.state.user.users.filter(
        (user) => user.id === props.id
      )[0];
    });

    const originalBilling = computed(() => {
      return root.$store.state.billing.billingList.filter(
        (billing) => billing.id === props.billingId
      )[0];
    });

    const currentAcademy = computed(
      () => root.$store.getters["academy/currentAcademy"]
    );

    const submit = async (payload) => {
      let updateBilling = convertFormToBilling(
        payload,
        props.id,
        currentAcademy.value.id
      );
      await root.$store.dispatch("billing/update", {
        id: props.billingId,
        billing: updateBilling,
      });
    };

    const cancel = () => {
      root.$router.go(-1);
    };

    return {
      form,
      billedUser,
      originalBilling,
      currentAcademy,
      submit,
      cancel,
    };
  },
});
</script>

<template>
  <billing-edit-template
    :originalBilling="originalBilling"
    :memberName="billedUser.name"
    @cancel="cancel"
    @submit="submit"
  />
</template>
